import { createContext } from 'react'

// Separate context value so provider file can only export components
const LoadingContext = createContext(undefined)

export default LoadingContext
